import React from 'react';
import { Container, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import './skills.css';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 13,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'light' ? '#0e8a8a' : '#308fe8',
  },
}));

const Skills = () => {
  return (
    <div className="skill-box" id="skill-section">
       <Container>
          <Grid container spacing={2}>
          <Grid xs={12} sm={7} md={7} lg={8} className="skill-left" data-aos="fade-up" data-aos-duration="1000">
          <Typography variant="h4" className="skill-heading">
            Skills<span>.</span>
          </Typography>
            <Typography variant="subtitle1" className="skill-sub-heading">
              As a Web developer, I specialize in developing responsive websites that are fast, user-friendly, and built using the most up-to-date best practises. 
            </Typography>
          
            <Typography variant="subtitle1" className="skill-sub-heading1">        
              My expertise include MERN Stack development with React JS and Node JS, as well as development of small and medium-sized web applications with interactive features and functionality.        
              In addition, I've worked as a MERN-Stack developer with popular technologies such as React JS, Next.js, and Node JS.
            </Typography>

            <Typography variant="subtitle1" className="skill-sub-heading2">      
               My main focus at Upstatement these days is developing accessible, inclusive products and digital experiences for a variety of clients.
           </Typography>
          </Grid>
          <Grid xs={12} sm={5} md={5} lg={4} sx={{pl:1}} className="skill-right" data-aos="fade-up" data-aos-duration="1000">
            <div className="skill-name">
              <Typography variant="h6" className="skills">
                  HTML & CSS
              </Typography>
              <BorderLinearProgress variant="determinate" value={85} />
            </div>
            <div className="skill-name">
              <Typography variant="h6" className="skills">
                  JavaScript
              </Typography>
              <BorderLinearProgress variant="determinate" value={70} />
            </div>
            <div className="skill-name">
              <Typography variant="h6" className="skills">
                  React JS
              </Typography>
              <BorderLinearProgress variant="determinate" value={75} />
            </div>
            <div className="skill-name">
              <Typography variant="h6" className="skills">
                  Node JS
              </Typography>
              <BorderLinearProgress variant="determinate" value={65} />
            </div>
            <div className="skill-name">
              <Typography variant="h6" className="skills">
                  MYSQL & MongoDB
              </Typography>
              <BorderLinearProgress variant="determinate" value={65} />
            </div>
            <div className="skill-name">
              <Typography variant="h6" className="skills">
                  React Native
              </Typography>
              <BorderLinearProgress variant="determinate" value={60} />
            </div>
            <div className="skill-name">
              <Typography variant="h6" className="skills">
                  Firebase
              </Typography>
              <BorderLinearProgress variant="determinate" value={65} />
            </div>

          </Grid>
          </Grid>
        </Container>
      
    </div>
  )
}

export default Skills
